import styled from 'styled-components';
import { CSSProperties, MouseEventHandler } from 'react';
import APopover from '../components/APopover';

export type LocalIconTypes =
  | 'chats.svg'
  | 'committee.svg'
  | 'dashboard.svg'
  | 'document.svg'
  | 'document-normal.svg'
  | 'Ellipse 1229.svg'
  | 'folder-search.svg'
  | 'horizontal-link.svg'
  | 'hospital.svg'
  | 'image.svg'
  | 'link.svg'
  | 'management.svg'
  | 'music-square.svg'
  | 'notification.svg'
  | 'panel.svg'
  | 'practical-programs.svg'
  | 'presention-chart.svg'
  | 'purpose.svg'
  | 'setting.svg'
  | 'survey.svg'
  | 'survey-shakhes.svg'
  | 'tag.svg'
  | 'task.svg'
  | 'task-management.svg'
  | 'tasks.svg'
  | 'teacher.svg'
  | 'text.svg'
  | 'trello.svg'
  | 'unknown-file.svg'
  | 'user.svg'
  | 'video-play.svg'
  | 'home.svg'
  | 'zip.svg'
  | 'search-normal.svg'
  | 'minimize.svg'
  | 'close-square.svg'
  | 'trash.svg'
  | 'duplicate.svg'
  | 'target.svg'
  | 'edit.svg'
  | 'mobile.svg'
  | 'password.svg'
  | 'sms.svg'
  | 'user-no-border.svg'
  | 'save.svg'
  | 'alert.svg'
  | 'ai-bot.svg'
  | 'file-check.svg'
  | 'stop-circle.svg'
  | 'play-circle.svg'
  | 'pause-circle.svg'
  | 'arrow-top.svg'
  | 'pdf.svg'
  | 'pause.svg'
  | 'thumb-up.svg'
  | 'thumb-down.svg'
  | 'play.svg'
  | 'tutorial.svg'
  | 'x.svg'
  | 'add-square.svg'
  | 'open-book.svg'
  | 'closed-book.svg'
  | 'gemini-logo.svg'
  | 'back-square.svg'
  | 'eye.svg'
  | 'eye-off.svg'
  | 'microphone.svg'
  | 'bot-stars.svg'
  | 'x-square-contained.svg'
  | 'check-square-contained.svg'
  | 'map.svg'
  | 'email.svg'
  | 'phone.svg'
  | 'color-picker.svg';

type Type = 'medium' | 'sm' | 'lg' | 'xs' | 'xlg';
interface IconProps {
  type: Type;
}
const StyledIcon = styled.div<IconProps>`
  height: 2rem;
  width: 2rem;
  background-color: ${(props) => props.color};
  -webkit-mask: ${(props) => `url(${props.src}) no-repeat center`};
  mask: ${(props) => `url(${props.src}) no-repeat center`};
  ${(props) => {
    switch (props.type) {
      case 'medium':
        return `
          mask-size: 1.75rem;
        `;
      case 'sm':
        return `
          mask-size: 1.5rem;
        `;
      case 'lg':
        return `
          mask-size: 2rem;
        `;
      case 'xs':
        return 'mask-size: 1rem;';
    }
    return '';
  }};

  ${(props) => props.hover && 'transform: all 1s ease-in-out;'};

  &:hover {
    cursor: ${(props) => props.isLink && 'pointer'};

    ${(props) =>
      props.hover &&
      `
      transform: scale(1.05);
      background-color: ${props.fillHoverColor};
    `}
  }
`;

const NoStyledIcon = styled.img`
  display: inline-block;
  margin: 0 0.5rem;
  ${(props) => {
    switch (props.type) {
      case 'medium':
        return `
          height: 1.75rem;
          width: 1.75rem;
        `;
      case 'sm':
        return `
          height: 1.5rem;
          width: 1.5rem;
        `;
      case 'lg':
        return `
          height: 2rem;
          width: 2rem;
        `;
      case 'xlg':
        return `
          height: 6rem;
          width: 6rem;
        `;
    }
    return '';
  }}

  ${(props) => props.hover && 'transform: all 1s ease-in-out;'};

  &:hover {
    cursor: ${(props) => props.isLink && 'pointer'};

    ${(props) =>
      props.hover &&
      `
      transform: scale(1.05);
      background-color: ${props.fillHoverColor};
    `}
  }
`;

function LocalIcon({
  iconName,
  color = 'var(--exact-white)',
  type = 'medium',
  onClick,
  style,
  isLink,
  title,
  hover = false,
  fillHoverColor = 'var(--exact-white)',
}: {
  iconName: LocalIconTypes;
  color?: string;
  type?: Type;
  onClick?: MouseEventHandler;
  style?: CSSProperties;
  isLink?: boolean;
  title?: string;
  hover?: boolean;
  fillHoverColor?: string;
}) {
  const target =
    color === 'no-color' ? (
      <NoStyledIcon
        src={`/assets/icons/${iconName}`}
        type={type}
        onClick={onClick}
        isLink={isLink}
        style={style}
        hover={hover}
        fillHoverColor={fillHoverColor}
      ></NoStyledIcon>
    ) : (
      <StyledIcon
        src={`/assets/icons/${iconName}`}
        color={color}
        type={type}
        onClick={onClick}
        style={style}
        isLink={isLink}
        hover={hover}
        fillHoverColor={fillHoverColor}
      ></StyledIcon>
    );
  if (title) {
    return (
      <APopover
        arrow
        curveBorder={true}
        target={target}
        placement="top"
        trigger="hover"
      >
        {typeof title === 'string' ? <div>{title}</div> : title}
      </APopover>
    );
  }
  return target;
}

export default LocalIcon;
